<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">

            <el-form-item label="关键字">
                <el-input v-model="formInline.keyword" placeholder="关键字"></el-input>
            </el-form-item>
            <el-form-item label="标题">
                <el-input v-model="formInline.title" placeholder="标题"></el-input>
            </el-form-item>
            <el-form-item label="平台">
                <el-select v-model="formInline.platformId" filterable clearable  placeholder="平台"  >
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleEdit({id:0,type:'text'})">新增</el-button>
            </el-form-item>
        </el-form>

            
            <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="60"></el-table-column>
<!--                <el-table-column prop="platformGroupName" label="公司"  width="120"></el-table-column>-->
                <el-table-column prop="platformName" label="平台" width="100"></el-table-column>
                <el-table-column prop="keyword"  label="关键字"></el-table-column>
                <el-table-column prop="title" :formatter="titleProccess" label="标题"></el-table-column>
                <el-table-column prop="type" :formatter="keywordType" label="类型" sortable  width="80">
                </el-table-column>
                <el-table-column prop="createTime" label="创建日期" sortable  width="180"></el-table-column>
                <el-table-column label="操作" fixed="right" width="180">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary"  size="mini"   @click="handleEdit(scope.row)">修改</el-button>
                            <el-tooltip class="item" effect="dark" content="点这里添加多套文案内容 " placement="top-end">
                                <el-button type="warning"  size="mini"  @click="handleAddMore(scope.row)">更多文案</el-button>
                            </el-tooltip>
                            <el-button type="danger" v-show="false" size="mini"  @click="handleDel(scope.row)">删除</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getKeywordsList,deleteKeyword,saveKeywords,getKeyword,getPlatformList,getMiniCardList} from '../../api/api';
    import uploadComponents from '@/components/upload';
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                keywordTypeData:[{"id":"text","name":"文本"},{"id":"news","name":"图文"},{"id":"image","name":"图片"},{"id":"coupon","name":"优惠券"},{"id":"miniCard","name":"小程序卡片"}],
                mediaData:[],
                cardData:[],
                loading:true,
                dialogFormVisible:false,
                form:{"id":0,"platformId":1,"keyword":"","type":"text","title":"","content":"","mediaId":"","url":"","imageUrl":""},
                textVisible:false,
                newsVisible:true,
                imageVisible:true,
                cardVisible:true,
                formInline:{
                    platformId:1,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                platformDisabled:false,
            }
        },
        //挂载时候执行
        mounted(){
            getPlatformList(this.formInline).then((res) => {
                this.platformData=res.data;
                //this.formInline.platformId=res.data[0].platformId;
                //初始化首页数据
                this.getList();
            });
            this.getCardList();
        },
        components:{
            uploadComponents
        },

        methods:{
            //定义查询方法
            keywordTypeChange(data){
                console.log(data);
                if(data=="text"){
                    this.textVisible=false;
                    this.newsVisible=true;
                    this.imageVisible=true;
                    this.cardVisible=true;
                }
                if(data=="image"){
                    this.textVisible=true;
                    this.newsVisible=true;
                    this.imageVisible=false;
                    this.cardVisible=true;
                }
                if(data=="news"){
                    this.textVisible=true;
                    this.newsVisible=false;
                    this.imageVisible=true;
                    this.cardVisible=true;
                }
                if(data=="coupon"){
                    this.textVisible=true;
                    this.newsVisible=true;
                    this.imageVisible=true;
                    this.cardVisible=true;
                }
                if(data=="miniCard"){
                    this.textVisible=false;
                    this.newsVisible=true;
                    this.imageVisible=true;
                    this.cardVisible=true;
                }
            },
            getList(){
                getKeywordsList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.keywordList.total;
                    this.listData = res.data.keywordList.list;
                    this.platformData=res.data.platFormList;
                    res.data.mediaList.forEach(item=> {
                        if(item.title!=null&&item.title.length>=93){
                            item.title=item.title.substring(0,93)+'...';
                        }
                        this.mediaData.push(item);
                    });
                })
            },
            getCardList(queryString){
                getMiniCardList({
                    type: 0,
                    title: queryString,
                    path: ''
                }).then((res) => {
                    this.cardData = res.data.value.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDel(row){
                if(confirm("确定删除关键字:"+row.keyword+"吗？")) {
                    deleteKeyword({id: row.id}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
            handleAddMore(data){
                //添加多套文本内容
                this.$router.push({path: '/wechatKeywordContent', query: {keyworldId: data.id}})
            },
            handleAdd(){
                this.dialogFormVisible = true;
                this.form.id=0;
                this.platformDisabled=false;
                this.form.keyword="";
                this.form.type="";
                this.form.title="";
                this.form.content="";
                this.form.mediaId="";
                this.form.imageUrl="";
                this.form.url="";
            },
            handleEdit(row){
                this.$router.push({path:'/wechatKeywordList/detail/:id',name: 'wechatKeywordDetail',params:{id:row.id},query:{type:row.type}})
            },
            save(data){
                console.log(data);
                if(data.keyword==""){
                    this.$message({
                        message:"请输入关键字",
                        type:'error'
                    });
                    return;
                }
                if(data.type==""){
                    this.$message({
                        message:"请选择关键字类型",
                        type:'error'
                    });
                    return;
                }
                if(data.type=="image"&&data.imageUrl==""){
                    this.$message({
                        message:"请选择图片",
                        type:'error'
                    });
                    return;
                }
                if(data.type=="news"&&data.mediaId==""){
                    this.$message({
                        message:"请选择素材",
                        type:'error'
                    });
                    return;
                }
                saveKeywords(data).then((res) => {
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },

            keywordType(row, column, cellValue) {
                for(var key in this.keywordTypeData){
                    if(this.keywordTypeData[key].id==cellValue) {
                        return this.keywordTypeData[key].name;
                    }
                }
            },
            titleProccess(row, column, cellValue) {
                if(row.type=="news"){
                    return row.mediaTitle;
                }else{
                    return cellValue;
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/wechat/wechatKeywordList.vue